export function getShellBaseUrl(): URL {
  // Read the application base from the <base> tag, which is set at container
  // startup from the SHELL_PUBLIC_PATH env var. __webpack_public_path__ with
  // publicPath:'auto' resolves to the JS asset directory (e.g. /central/js/)
  // rather than the application base (/central/), causing vue-router to
  // construct wrong URLs when processing single-spa's synthetic popstate events.
  const baseEl = document.querySelector('base');
  if (baseEl?.href) return new URL(baseEl.href);
  return new URL(__webpack_public_path__, window.location.origin);
}

export function getShellBasePath(): string {
  return getShellBaseUrl().pathname;
}

export default {};
